import cn from "classnames";
import BidSyncStatusInfo from "components/shared/bidSyncStatusInfo";
import CargoOwnerShareAccess from "components/shared/cargoOwnerShareAccess";
import InlineBtn from "components/shared/inlineBtn";
import Loader from "components/shared/loader";
import Notifys from "components/shared/notifys";
import TypeOptions from "components/shared/typeOptionsShow";
import { comparePointsWithSegments, formatExtendedProp, parallelItemChangeModalTitle } from "helpers/bid";
import { getFirstPoint, getLastPoint, sortedPoints } from "helpers/bidpoint";
import { dateTimeToView, dateToView } from "helpers/date";
import debounceAccumulate from "helpers/debounceAccumulate";
import {
    bidChatDomainTypesEnum,
    bidPointOptionFlags,
    bidPointOptionFlagsEnum,
    chatTypesEnum,
    documentAssignmentStatuses,
    documentAssignmentStatusesEnum,
    featureModuleTypesEnum,
    forwardingOrderChangeBehavioursEnum,
    mapObjectTypesEnum,
    parallelPointBehaviorsEnum,
    parcelRelationTypesEnum,
    sourceTypes,
} from "helpers/enums";
import { serializeReq } from "helpers/form";
import { paths } from "helpers/paths";
import { isRegionDryingPeriodsEnabledForClients } from "helpers/regionDryingPeriods";
import { canManageOrganization, enumLabel, formatNumber, ymEvent } from "helpers/system";
import groupBy from "lodash/groupBy";
import pick from "lodash/pick";
import moment from "moment";
import policy from "policies";
import Tooltip from "rc-tooltip";
import React, { Component, Fragment } from "react";
import SignalRConnection from "services/signalRConnection";
import { getBidItemsChanges } from "sources/bidItemChanges";
import {
    applyItemChangePoints,
    checkForwardingOrderCarHasChanged,
    checkItemsBeforeParallelPoint,
    getBid,
    getInfoForRecalculation,
    getPointPrediction,
    getRegionDryingPeriodIds,
    getUnstableZones,
    patchCloseBid,
} from "sources/books/bids";
import { giveAccessToBids } from "sources/books/cargoOwners";
import { getBidItem } from "sources/books/emergencyArea";
import { getPlannedRefuelings } from "sources/books/refueling";
import { getBidItem as getRouteControlBidPoints } from "sources/books/routeControlPoints";
import { getCarStops } from "sources/books/trucks";
import { getList as getUserEntityOptions } from "sources/catalogs";
import { getCombinedProperties } from "sources/extendedProperties";
import { findCarLocation, getCarsRoutesByBidId, getLastCarLocationForBidId, getRouteByBidId } from "sources/map";
import { showDefaultRouteOptions } from "sources/profile/organization";
import connect from "./bodyConnect";
import {
    BidActions,
    BidDocuments,
    BidEBills,
    BidHead,
    BidItemsChanges,
    BidParcels,
    BidShippingOrder,
    CargoOwner,
    CargoPoints,
    CompoundInfo,
    Contract,
    ContractNumber,
    Driver,
    FuelInfo,
    LegalPerson,
    Logist,
    Mechanic,
    Pricing,
    Timeline,
    TollRoads,
    Truck,
} from "./partials";

class BidShow extends Component {
    state = {
        bid: {},
        isLoading: true,
        extendedPropertiesConfig: { bid: [], bidPoints: [], cargo: [] },
        expandedRangeTime: false,
        recalculationData: null,
    };

    constructor(props) {
        super(props);
        const { profile, roles, match, organization } = props;
        const { distanceWithoutEmptyMileage, distance } = this.state.route || {};
        const fullKms = distanceWithoutEmptyMileage
            ? Math.round(distanceWithoutEmptyMileage / 1000)
            : distance
              ? Math.round(distance / 1000)
              : 0;
        this.receiveUpdate = debounceAccumulate(
            this.receiveUpdate,
            2500,
            (acc, data) => ({
                ...acc,
                ...data,
                updateRoute: acc.updateRoute || data.updateRoute,
                updateBid: acc.updateBid || data.updateBid,
                updateDocuments: acc.updateDocuments || data.updateDocuments,
            }),
            {},
        );
        this.bidPolicy = policy("bid", {
            user: { profile, roles, organization },
            record: {},
            options: {
                isOpened: match.params.type === "rate",
                distance,
                fullKms,
                refueling: this.state.refueling,
            },
        });
        this.temperatureRegimeEnabled = profile.availableFeatureModules.includes(
            featureModuleTypesEnum.TemperatureRegime,
        );
    }

    componentDidMount() {
        this.getItem(this.props).then(() => {
            const { id } = this.props;
            this.connection = new SignalRConnection({
                url: "/signalr/bids",
                connectionParams: id,
                actions: [{ name: "Update", action: this.receiveUpdate }],
                joinActionName: "Join",
                leaveActionName: "Leave",
            });
        });
        const { roles, profile } = this.props;
        getCombinedProperties({ excludeHidden: true, isRelation: false }).then((extendedPropertiesConfig) =>
            this.setState({ extendedPropertiesConfig }),
        );
        getUserEntityOptions().then((userEntityOptions) => this.setState({ userEntityOptions }));
        if (policy("user", { user: { roles, profile } }).hasWorkRestInfoAccess()) {
            this.props.getWorkRestInfo();
        }
        this.props.mergeMapData({ refuelingServiceType: this.props.refuelingServiceType, compareBidId: this.props.id });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.mapBid && nextProps.match.params.id !== nextProps.mapBid) {
            this.resetMapBid();
        }
        if (nextProps.refuelingServiceType !== this.props.refuelingServiceType) {
            this.props.mergeMapData({
                refuelingServiceType: nextProps.refuelingServiceType,
                compareBidId: nextProps.id,
            });
        }
        if (this.props.match.params.id !== nextProps.match.params.id || nextProps.shouldUpdateBid) {
            this.getItem(nextProps).then(() => {
                if (this.props.match.params.id !== nextProps.match.params.id) {
                    this.connection && this.connection.disconnect();
                    const { id } = nextProps;
                    this.connection = new SignalRConnection({
                        url: "/signalr/bids",
                        connectionParams: id,
                        actions: [{ name: "Update", action: this.receiveUpdate }],
                        joinActionName: "Join",
                        leaveActionName: "Leave",
                    });
                }
            });
            nextProps.changeShouldUpdateBid(false);
        }
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        const { profile, roles, organization, match } = nextProps;
        const { distanceWithoutEmptyMileage, distance } = nextState.route || {};
        const fullKms = distanceWithoutEmptyMileage
            ? Math.round(distanceWithoutEmptyMileage / 1000)
            : distance
              ? Math.round(distance / 1000)
              : 0;
        this.bidPolicy = policy("bid", {
            user: { profile, roles, organization },
            record: {
                ...(nextState.bid || this.state.bid),
                route: nextState.route || this.state.route,
                emulatedSegments: nextState.emulatedSegments || this.state.emulatedSegments,
            },
            options: {
                isOpened: match.params.type === "rate",
                distance,
                fullKms,
                refueling: this.state.refueling,
            },
        });
    }

    componentWillUnmount() {
        this.resetMapBid();

        this.connection?.disconnect();
    }

    receiveUpdate = (data) => {
        const { id, updateModal } = this.props;
        if (data === null || data.id !== Number(id)) {
            return;
        }

        if (data.updateDocuments) {
            updateModal({ documentsUpdatedAt: Date.now() });
        }

        if (this.state.bid.version === data.version) {
            return;
        }

        if (data.updateRoute) {
            this.getItem(this.props);
        } else if (data.updateBid) {
            getBid(id).then((bid) => {
                this.setState({ bid });
                this.props.mergeMapData({
                    bidAverageRateInfo: this.getBidAverageRateInfo(bid),
                    compareBidId: id,
                });
            });
        }
    };

    resetMapBid = () => {
        const { mergeMapData, mergeMapHeader } = this.props;
        mergeMapData({
            route: null,
            carRoutes: null,
            currentBid: null,
            bidPoints: null,
            bidStatus: null,
            bidLastCarLocation: null,
            routeControlPoints: null,
            carStops: null,
            refueling: null,
            updatePoint: null,
            canDrag: false,
            bidItemsChanges: null,
            expandedRangeTime: false,
            recalculationData: null,
            refuelingServiceType: null,
            externalBidOutput: null,
            hasExternalBid: false,
            carId: null,
            pointPrediction: null,
            postamats: null,
            defaultRouteOptions: null,
            pointsNotComparedToSegments: null,
            refreshBid: null,
            regionDryingPeriodIds: null,
            bidAverageRateInfo: null,
        });
        mergeMapHeader({});
    };

    getBidAverageRateInfo = (bid) => ({
        averageRateByDestination: bid.averageRateByDestination ?? null,
        averageRateDate: bid.bidPoints?.[0]?.planEnterDate ?? null,
        bidAverageRate: bid.averageRate ?? null,
    });

    getItem = (nextProps) => {
        const { roles, id, mergeMapData, profile, mergeMapHeader, refuelingSettings } = nextProps || this.props;
        const nextState = {
            isLoading: true,
            profile,
        };
        this.setState(nextState);
        this.resetMapBid();
        mergeMapData({ isLoading: true, currentBid: id });
        const loadRoute = (bid) => {
            Promise.all([getRouteByBidId(id), showDefaultRouteOptions()]).then(([route, defaultRouteOptions]) => {
                const pointsNotComparedToSegments = comparePointsWithSegments(bid.bidPoints, route);
                const mapHeaderData = { ...this.timelineProps, route, name: "routeInfo", compareBidId: id };
                this.setState({ route, routeIsLoaded: true });
                setTimeout(() => {
                    mergeMapHeader(mapHeaderData);
                }, 0);
                mergeMapData({
                    route,
                    defaultRouteOptions,
                    externalBidOutput: bid.externalBidOutput,
                    hasExternalBid: bid.hasExternalBid,
                    carId: bid.car?.carId,
                    bidStatus: bid.status,
                    itemChangePoints: bid.itemChangePoints,
                    updateItemChangePoint: this.updateItemChangePoint,
                    canDragItemChangePoints: this.bidPolicy.canSeeBidItemChanges(),
                    bidPoints: sortedPoints(bid.bidPoints),
                    bid,
                    updatePoint: this.updatePoint,
                    canDrag: this.bidPolicy.canDragPoint(),
                    isLoading: false,
                    compareBidId: id,
                    expandedRangeTime: this.state.expandedRangeTime,
                    pointsNotComparedToSegments,
                    refreshBid: this.getItem,
                    bidAverageRateInfo: this.getBidAverageRateInfo(bid),
                    toggleExpandedRangeTime: () => {
                        const newVal = !this.state.expandedRangeTime;
                        this.setState({ expandedRangeTime: newVal });
                        mergeMapData({ expandedRangeTime: newVal, isLoading: true, currentBid: id });
                        const reqs = [
                            getCarsRoutesByBidId(id, newVal).then((carRoutes) =>
                                mergeMapData({ carRoutes, compareBidId: id }),
                            ),
                        ];
                        if (!this.state.recalculationData) {
                            reqs.push(
                                getInfoForRecalculation(id).then((data) => {
                                    mergeMapData({ recalculationData: data, compareBidId: id });
                                    this.setState({ recalculationData: data });
                                }),
                            );
                        }
                        Promise.all(reqs).then(() => mergeMapData({ isLoading: false, compareBidId: id }));
                    },
                });
                if (this.bidPolicy.canViewPlanRefuelings({ refuelingSettings })) {
                    getPlannedRefuelings(bid.id).then((refueling = {}) => {
                        if (refueling) {
                            refueling.plannedRefuelings = refueling.plannedRefuelings.filter((item) =>
                                route.segments.some((segment) => segment.mapObjectFrom.id === item.mapObject.id),
                            );
                        }
                        mergeMapData({ refueling, compareBidId: id });
                        this.setState({
                            refueling,
                            refuelingIsLoaded: true,
                            pointsOrderedByRoute: this.getPointsOrderedByRoute(route, refueling, bid),
                        });
                    });
                } else {
                    this.setState({
                        refuelingIsLoaded: true,
                        refueling: {},
                        pointsOrderedByRoute: this.getPointsOrderedByRoute(route, {}, bid),
                    });
                }
            });
            getCarsRoutesByBidId(id).then((carRoutes) => {
                this.setState({
                    emulatedSegments: (carRoutes || []).reduce(
                        (acc, item) => acc.concat(item.emulatedSegments || []),
                        [],
                    ),
                });
                mergeMapData({ carRoutes, compareBidId: id, updateCarRoutes: this.updateCarRoutes });
            });
            getLastCarLocationForBidId(id).then((bidLastCarLocation) => {
                mergeMapData({ bidLastCarLocation, compareBidId: id });
                this.setState({ bidLastCarLocation });
            });
            getBidItem(id).then((emergencyAreaPoints) => mergeMapData({ emergencyAreaPoints, compareBidId: id }));
            if (profile.availableFeatureModules.includes(featureModuleTypesEnum.RouteControlPoints)) {
                getRouteControlBidPoints(id).then((routeControlPoints) =>
                    mergeMapData({ routeControlPoints, compareBidId: id }),
                );
            }
            if (bid.car) {
                const firstPoint = getFirstPoint(bid.bidPoints);
                const lastPoint = getLastPoint(bid.bidPoints);
                const filter = {
                    carId: bid.car?.carId,
                    startedAt: {
                        ge: new Date(firstPoint.autoEnteredAt || firstPoint.planEnterDateOffset),
                        le: new Date(lastPoint.autoEnteredAt || lastPoint.planEnterDateOffset),
                    },
                };
                getCarStops(filter).then((carStops) =>
                    mergeMapData({ carStops, carStopsLoadedAt: Date.now(), compareBidId: id }),
                );
            }
            if (bid.hasItemsChange) {
                getBidItemsChanges(id, true).then((data) => {
                    this.setState({ itemChangesHistory: data });
                    const { dataFormatted } = Object.entries(groupBy(data, "startedAt")).reduce(
                        (acc, [dateTime, itemChanges], index) => {
                            const { dataFormatted, nearestData } = acc;
                            itemChanges.forEach((el) => {
                                const name = el.itemType.toLowerCase();
                                el.prevData = { ...nearestData[name] };
                                nearestData[name] = el;
                            });
                            index > 0 &&
                                nearestData.car &&
                                dataFormatted.push({
                                    params: { carId: nearestData.car.itemId, dateTime },
                                    itemChanges,
                                });
                            return { dataFormatted, nearestData };
                        },
                        { dataFormatted: [], nearestData: { car: null, trailer: null, driver: null } },
                    );
                    Promise.all(dataFormatted.map(findCarLocation)).then((bidItemsChanges) => {
                        this.setState({ bidItemsChanges });
                        mergeMapData({ bidItemsChanges });
                    });
                });
            }
            const { availableFeatureModules } = this.props.profile;
            if (
                availableFeatureModules.includes(featureModuleTypesEnum.UnstableZones) &&
                canManageOrganization(roles)
            ) {
                getUnstableZones(id).then((unstableZones) => mergeMapData({ unstableZones, compareBidId: id }));
            }
            if (isRegionDryingPeriodsEnabledForClients) {
                getRegionDryingPeriodIds(id).then((regionDryingPeriodIds) =>
                    mergeMapData({ regionDryingPeriodIds: regionDryingPeriodIds ?? [], compareBidId: id }),
                );
            }
        };
        return getBid(id).then((bid) => {
            setTimeout(() => {
                this.setState({ isLoading: false, bid }, () => loadRoute(bid));
            }, 500);
        });
    };

    updateCarRoutes = () => {
        const { id, mergeMapData } = this.props;
        mergeMapData({ isLoading: true, currentBid: id });
        getCarsRoutesByBidId(id).then((carRoutes) =>
            mergeMapData({ carRoutes, compareBidId: id, updateCarRoutes: this.updateCarRoutes, isLoading: false }),
        );
    };

    updateItemChangePoint = (mapObject, point) => {
        const {
            id,
            shiftDriverId,
            shiftSecondaryDriverId,
            shiftTrailerId,
            shiftCarId,
            planEnterDate,
            planLeaveDate,
            changeFlag,
        } = point;
        const newPoint = {
            id,
            shiftDriverId,
            shiftSecondaryDriverId,
            shiftTrailerId,
            shiftCarId,
            planEnterDate,
            planLeaveDate,
            mapObject,
            changeFlag,
        };
        const req = (extraParams = {}) =>
            applyItemChangePoints({
                bidId: this.props.id,
                ...extraParams,
                items: [newPoint],
            }).then((res) => res && this.getItem());
        const hasParallelBid = this.state.bid.itemChangePoints.some((item) => item.parallelBidId);
        const { autoEnteredAt, enteredAt, enteredAtByLogist } = this.state.bid.bidPoints[0];
        const firstBidPointEntered = !!(autoEnteredAt || enteredAt || enteredAtByLogist);
        const promises = [];
        if (hasParallelBid && !firstBidPointEntered) {
            promises.push(() =>
                checkItemsBeforeParallelPoint({ bidId: this.props.id, pointToApply: newPoint }).then(
                    ({ willBeChanged, parallelBidId, car, driver, trailer }) => {
                        return new Promise((resolve) => {
                            if (willBeChanged) {
                                this.props.addModal({
                                    name: "parallelBidChange",
                                    windowMod: "sm",
                                    title: parallelItemChangeModalTitle(car, driver, trailer),
                                    parallelBidId,
                                    withoutEscClose: true,
                                    actions: {
                                        update: () =>
                                            resolve({ parallelPointBehavior: parallelPointBehaviorsEnum.Update }),
                                        delete: () =>
                                            resolve({ parallelPointBehavior: parallelPointBehaviorsEnum.Delete }),
                                        cancel: () => resolve(false),
                                    },
                                });
                            } else {
                                return resolve({});
                            }
                        });
                    },
                ),
            );
        }
        if (this.state.bid.forwardingOrder) {
            promises.push(() =>
                checkForwardingOrderCarHasChanged({
                    bidId: this.props.id,
                    pointToApply: newPoint,
                }).then(({ willBeChanged }) => {
                    return new Promise((resolve) => {
                        if (willBeChanged) {
                            this.props.addModal({
                                name: "forwardingOrderCarChange",
                                windowMod: "sm",
                                title: "Обратите внимание",
                                withoutEscClose: true,
                                actions: {
                                    update: () =>
                                        resolve({
                                            forwardingOrderCarChangeBehaviour:
                                                forwardingOrderChangeBehavioursEnum.Update,
                                        }),
                                    delete: () =>
                                        resolve({
                                            forwardingOrderCarChangeBehaviour:
                                                forwardingOrderChangeBehavioursEnum.Delete,
                                        }),
                                    cancel: () => resolve(false),
                                },
                            });
                        } else {
                            resolve({});
                        }
                    });
                }),
            );
        }

        if (promises.length > 0) {
            const extraOptionsArr = [];
            const promisesSeries = async () => {
                for (let i = 0; i < promises.length; i++) {
                    const data = await promises[i]();
                    extraOptionsArr.push(data);
                }
            };
            return promisesSeries().then(() => {
                if (extraOptionsArr.some((item) => !item)) {
                    return this.setState({ isLoading: false });
                }
                return req(extraOptionsArr.reduce((acc, item) => ({ ...acc, ...item }), {}));
            });
        } else {
            return req();
        }
    };

    updatePoint = (geozone, pointId) => {
        const pickedAttrs = ["bidPoints", "id"];
        const { bidPoints } = this.state.bid;
        const formData = pick(this.state.bid, pickedAttrs);
        let showPolygonConfirmModal = false;
        formData.bidPoints = bidPoints.map((point) => {
            const { counterparty, customPointType } = point;
            if (counterparty) {
                point.cargoOwnerDictionaryItemId = counterparty.id;
            }
            if (customPointType) {
                point.customPointTypeId = customPointType.id;
            }
            if (point.id !== pointId) {
                return point;
            }
            if (point.geozone.coordinates) {
                showPolygonConfirmModal = true;
            }
            geozone.radius = point.geozone.radius;
            return { ...point, geozone };
        });
        const formatted = serializeReq(formData);
        formatted.bidPoints.forEach((x) => {
            x.planEnterDate = moment(x.planEnterDate).format("YYYY-MM-DDTHH:mm");
        });
        if (showPolygonConfirmModal) {
            return new Promise((resolve) => {
                this.props.modal({
                    name: "confirm",
                    title: "Перенос точки",
                    text: "Для фиксации въезда на точку используется индивидуальная область. После переноса эта область будет заменена на круг, действительно перенести точку?",
                    onSuccessAction: () => this.getItem(this.props),
                    action: () => patchCloseBid(formatted),
                    onCloseAction: () => resolve(),
                    buttons: { confirm: "Да", cancel: "Нет" },
                });
            });
        } else {
            return patchCloseBid(formatted).then(() => this.getItem(this.props));
        }
    };

    updateBidPointsOrder = (bidPoints) => {
        const formData = {
            id: this.state.bid.id,
            bidPoints: bidPoints.map((point) => ({
                ...point,
                ...(point.counterparty ? { cargoOwnerDictionaryItemId: point.counterparty.id } : {}),
                ...(point.customPointType ? { customPointTypeId: point.customPointType.id } : {}),
            })),
        };
        const formatted = serializeReq(formData);
        formatted.bidPoints.forEach((point) => {
            point.planEnterDate = moment(point.planEnterDate).format("YYYY-MM-DDTHH:mm");
            if (point.planLeaveDate) {
                point.planLeaveDate = moment(point.planLeaveDate).format("YYYY-MM-DDTHH:mm");
            }
            if (point.secondaryPlanEnterDate) {
                point.secondaryPlanEnterDate = moment(point.secondaryPlanEnterDate).format("YYYY-MM-DDTHH:mm");
            }
        });
        return patchCloseBid(formatted).then((result) => {
            if (!result) {
                return false;
            }
            return this.getItem(this.props).then(() => true);
        });
    };

    back = () => {
        this.props.mergeAllParams({});
        this.props.mergeNotifysParams({});
        this.props.back();
    };

    renderActions = () => {
        if (!this.bidPolicy.isOwner() || !this.state.bid || this.bidPolicy.isReadOnlyTruckingOrganizationUser()) {
            return null;
        }
        const { id, history, mergeParams, modal, organization, refuelingServiceType, mergeMapData, refuelingSettings } =
            this.props;
        const { distanceWithoutEmptyMileage, distance } = this.state.route || {};
        const { activeMileage } = this.state.bid || {};
        const activeKms = activeMileage ? Math.round(activeMileage / 1000) : 0;
        const planKms = distanceWithoutEmptyMileage
            ? Math.round(distanceWithoutEmptyMileage / 1000)
            : distance
              ? Math.round(distance / 1000)
              : 0;
        const props = {
            id,
            modal,
            history,
            mergeParams,
            mergeMapData,
            organization,
            refuelingServiceType,
            getItem: this.getItem,
            bidPolicy: this.bidPolicy,
            back: this.back,
            setLoading: (isLoading) => this.setState({ isLoading }),
            activeKms,
            planKms,
            refuelingSettings,
            ...this.state,
        };
        return <BidActions {...props} />;
    };

    renderHead = () => {
        const { id, mergeParams, modal, organization } = this.props;
        const props = {
            ...this.state,
            id,
            back: this.back,
            mergeParams,
            refresh: this.getItem,
            modal,
            bidPolicy: this.bidPolicy,
            organization,
        };
        return <BidHead {...props} />;
    };

    renderTruck = () => {
        if (!this.bidPolicy.canSeeAdditionalInfo()) {
            return null;
        }
        const props = { ...this.state, history: this.props.history, organization: this.props.organization };
        const { enums, modal, roles } = this.props;
        return (
            <Truck
                {...props}
                enums={enums}
                modal={modal}
                roles={roles}
                updateCarPlanningComment={this.updateCarPlanningComment}
            />
        );
    };

    updateCarPlanningComment = (data) => {
        if (!data) {
            return;
        }
        const { planningComment } = data;
        const { car } = this.state.bid;
        car.planningComment = planningComment;
        this.setState({ bid: { ...this.state.bid, car } });
    };

    renderLogist = () => {
        if (!this.bidPolicy.canSeeAdditionalInfo()) {
            return null;
        }
        const { car } = this.state.bid;
        return <Logist {...car} />;
    };

    renderMechanic = () => {
        if (!this.bidPolicy.canSeeAdditionalInfo()) {
            return null;
        }
        const { mechanic } = this.state.bid.car;
        return <Mechanic mechanic={mechanic} />;
    };

    renderLegalPerson = () => {
        if (!this.bidPolicy.canSeeAdditionalInfo()) {
            return null;
        }
        return <LegalPerson {...this.state.bid} />;
    };

    renderCargoOwner = () => <CargoOwner {...this.state.bid} roles={this.props.roles} modal={this.props.modal} />;

    renderContractNumber = () => <ContractNumber {...this.state.bid} roles={this.props.roles} />;

    renderContract = () => <Contract {...this.state.bid} roles={this.props.roles} />;

    renderCreatedAtInfo = () => {
        const { createdAt, sourceType, createdBy } = this.state.bid;
        const sourceTypeObj = sourceTypes.find((item) => item.value === sourceType);
        const sourceTypeLabel = sourceTypeObj && sourceTypeObj.label;
        return (
            <>
                <div className="show-bid__main-info--title">Создана</div>
                <div className="show-bid__main-info--value" data-test-id="created-at">
                    {createdBy.shortName}
                    {sourceTypeLabel && <span className="badge badge-primary ml-1">{sourceTypeLabel}</span>}
                    <span className="ml-1">{dateTimeToView(createdAt, "DD.MM.YYYY HH:mm (Z)")}</span>
                </div>
            </>
        );
    };

    renderDistributionBidInfo = () => {
        const { distributionBidId } = this.state.bid;
        if (!distributionBidId) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Заказ</div>
                <div className="show-bid__main-info--value" data-test-id="distribution-bid-id">
                    <a href={paths.distributionBidShow(distributionBidId)} rel="noopener noreferrer" target="_blank">
                        {distributionBidId}
                    </a>
                </div>
            </>
        );
    };

    renderApprovedAtInfo = () => {
        const { organization } = this.props;
        const { approvedAt, approvedBy, isEmptyMileageBid } = this.state.bid;
        if (!organization.usesBidsApproval || !approvedAt || isEmptyMileageBid) {
            return null;
        }
        const { shortName } = approvedBy || {};
        return (
            <>
                <div className="show-bid__main-info--title">Согласована</div>
                <div className="show-bid__main-info--value" data-test-id="approved-at">
                    {shortName && <span className="pr-1">{shortName}</span>}
                    {dateTimeToView(approvedAt, "DD.MM.YYYY HH:mm (Z)")}
                </div>
            </>
        );
    };

    renderExtendedProperties = (config, values) => {
        return config.map((prop) => {
            if (!values) {
                return null;
            }
            const valueObj = values.find((item) => item.propertyName === prop.propertyName);
            return (
                <Fragment key={prop.id}>
                    <div className="show-bid__main-info--title" style={prop.order ? { order: prop.order } : {}}>
                        {prop.displayName}
                    </div>
                    <div
                        className="show-bid__main-info--value"
                        data-test-id="extended-property"
                        style={prop.order ? { order: prop.order } : {}}
                    >
                        {valueObj ? formatExtendedProp(valueObj.value, prop.typeCode) : ""}
                    </div>
                </Fragment>
            );
        });
    };

    renderStartedAtInfo = () => {
        const { startedAt, startedBy } = this.state.bid;
        const { shortName } = startedBy || {};
        if (!startedAt && !startedBy) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Запущена</div>
                <div className="show-bid__main-info--value" data-test-id="started-at">
                    {shortName && <span className="pr-1">{shortName}</span>}
                    {startedAt && dateTimeToView(startedAt, "DD.MM.YYYY HH:mm (Z)")}
                </div>
            </>
        );
    };

    renderResponsibleInfo = () => {
        const { responsible } = this.state.bid;
        const { shortName } = responsible || {};
        if (!responsible) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Ответственный</div>
                <div className="show-bid__main-info--value" data-test-id="responsible">
                    {shortName && <span className="pr-1">{shortName}</span>}
                </div>
            </>
        );
    };

    renderComment = () => {
        const { comment } = this.state.bid;
        if (!comment) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Комментарий</div>
                <div className="show-bid__main-info--value" data-test-id="comment">
                    {comment}
                </div>
            </>
        );
    };

    renderClientBidNumber = () => {
        const { clientBidNumber } = this.state.bid;
        if (!clientBidNumber) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Номер заявки клиента</div>
                <div className="show-bid__main-info--value" data-test-id="clientBidNumber">
                    {clientBidNumber}
                </div>
            </>
        );
    };

    renderClientBidDate = () => {
        const { clientBidDate } = this.state.bid;
        if (!clientBidDate) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Дата заявки клиента</div>
                <div className="show-bid__main-info--value" data-test-id="clientBidDate">
                    {dateToView(clientBidDate)}
                </div>
            </>
        );
    };

    renderSalesManagerInfo = () => {
        const { salesManager } = this.state.bid;
        const { shortName } = salesManager || {};
        if (!salesManager) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Менеджер по продажам</div>
                <div className="show-bid__main-info--value" data-test-id="sales-manager">
                    {shortName && <span className="pr-1">{shortName}</span>}
                </div>
            </>
        );
    };

    renderWeightInfo = () => {
        const { axisLoad } = this.state.bid;
        if (!axisLoad) {
            return null;
        }
        const { value, secondaryValue, averageValue, trailerValue, fixedAt } = axisLoad;
        return (
            <>
                <div className="show-bid__main-info--title">Средний вес</div>
                <div className="show-bid__main-info--value" data-test-id="weight-info">
                    <strong className="text-muted">Данные от:</strong> {dateTimeToView(fixedAt, "DD.MM.YYYY HH:mm (Z)")}
                    <br />
                    <strong className="text-muted">Ось 1:</strong> {formatNumber(value)} т.
                    <br />
                    <strong className="text-muted">Ось 2:</strong> {formatNumber(secondaryValue)} т.
                    <br />
                    <strong className="text-muted">Средний вес:</strong> {formatNumber(averageValue)} т.
                    <br />
                    <strong className="text-muted">Вес прицепа:</strong> {formatNumber(trailerValue)} т.
                </div>
            </>
        );
    };

    renderDocumentAssigmentStatus = () => {
        const { availableFeatureModules } = this.props.profile;
        if (!availableFeatureModules.includes(featureModuleTypesEnum.DocumentAssignment)) {
            return null;
        }
        const { documentAssignment, createDocumentAssignment } = this.state.bid;
        const { status, id } = documentAssignment || {};
        const { DocumentsRejected, DocumentsApproved, Completed } = documentAssignmentStatusesEnum;
        const classNames = cn("badge", {
            "badge-primary": ![DocumentsRejected, DocumentsApproved, Completed].includes(status),
            "badge-success": [DocumentsApproved, Completed].includes(status),
            "badge-danger": DocumentsRejected === status,
        });

        return (
            <>
                <div className="show-bid__main-info--title">Создать водителю задачу по сдаче документов</div>
                <div className="show-bid__main-info--value" data-test-id="create-document-assignment">
                    {createDocumentAssignment ? "Да" : "Нет"}
                </div>
                {id && (
                    <>
                        <div className="show-bid__main-info--title">Номер задачи по сдаче документов</div>
                        <div className="show-bid__main-info--value">{id}</div>
                    </>
                )}
                <div className="show-bid__main-info--title">Статус сдачи документов</div>
                <div className="show-bid__main-info--value" data-test-id="document-assignment">
                    <span className={classNames}>{enumLabel(documentAssignmentStatuses, status, "Нет данных")}</span>
                </div>
            </>
        );
    };

    renderTypeOptions = () => {
        const {
            userEntityOptions,
            bid: { typeOptions },
        } = this.state;
        if (!typeOptions || typeOptions.length === 0) {
            return null;
        }
        const { enums } = this.props;
        const props = { typeOptions, enums, userEntityOptions };
        return <TypeOptions {...props} />;
    };

    renderPricing = () => {
        const { enums, toChat, organizationTimezone, roles, organization, modal, profile } = this.props;
        const props = {
            ...this.state,
            modal,
            roles,
            enums,
            toChat,
            organizationTimezone,
            organization,
            profile,
            refresh: this.getItem,
            bidPolicy: this.bidPolicy,
        };
        return <Pricing {...props} />;
    };

    renderCompoundInfo = () => {
        const { compoundBidIds } = this.state.bid;
        const { id } = this.props;

        if (!compoundBidIds) {
            return null;
        }
        const props = { compoundBidIds, id };
        return <CompoundInfo {...props} />;
    };

    renderDriver = () => {
        const { enums, toChat, organizationTimezone, modal } = this.props;
        const props = {
            ...this.state,
            modal,
            enums,
            toChat,
            organizationTimezone,
            bidPolicy: this.bidPolicy,
            refreshBidData: () => this.getItem(this.props),
        };
        return <Driver {...props} />;
    };

    renderCargoPoints = () => {
        const props = { ...this.state };
        const { enums } = this.props;
        const canUseMultipleBidCargos = this.bidPolicy.canUseMultipleBidCargos();

        return (
            <CargoPoints
                {...props}
                enums={enums}
                renderExtendedProperties={this.renderExtendedProperties}
                canUseMultipleBidCargos={canUseMultipleBidCargos}
            />
        );
    };

    renderTollRoads = () => {
        const { tollRoadSegments } = this.state.route || {};

        if (!tollRoadSegments || !tollRoadSegments.length > 0) {
            return null;
        }

        return <TollRoads tollRoads={tollRoadSegments} modal={this.props.modal} route={this.state.route} />;
    };

    getPointsOrderedByRoute = (route, refueling, bid) => {
        if (!route?.segments || route.segments.length === 0) {
            return bid.bidPoints.map((point) => ({ type: point.geozone.type, data: point }));
        }

        const getBidPoint = (id) => bid.bidPoints.find((item) => item.geozone.id === id);
        const getGasStation = (id) => (refueling.plannedRefuelings || []).find(({ mapObject }) => mapObject.id === id);
        const getItemChangePoint = (id) => bid.itemChangePoints.find(({ mapObjectId }) => mapObjectId === id);

        const getMapObjectData = (mapObject) => {
            if (!mapObject) {
                return null;
            }
            switch (mapObject.type) {
                case mapObjectTypesEnum.BidPoint:
                case mapObjectTypesEnum.StartBidPoint:
                case mapObjectTypesEnum.ServicePoint:
                case mapObjectTypesEnum.CounterpartyPoint:
                    return { type: mapObject.type, data: getBidPoint(mapObject.id) };
                case mapObjectTypesEnum.GasStation:
                    return { type: mapObjectTypesEnum.GasStation, data: getGasStation(mapObject.id) };
                case mapObjectTypesEnum.ItemChangePoint:
                    return { type: mapObjectTypesEnum.ItemChangePoint, data: getItemChangePoint(mapObject.id) };
            }
        };

        const firstPoint = getMapObjectData(route.segments[0].mapObjectFrom);
        return (route.segments || []).reduce(
            (acc, segment) => {
                const item = getMapObjectData(segment.mapObjectTo);
                if (item?.data) {
                    acc.push(item);
                }
                return acc;
            },
            firstPoint?.data ? [firstPoint] : [],
        );
    };

    renderTimeline = () => {
        const { pointsOrderedByRoute } = this.state;
        if (!pointsOrderedByRoute) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="absolute-center" />
                </div>
            );
        }

        return (
            <Timeline
                {...this.timelineProps}
                profile={this.props.profile}
                organization={this.props.organization}
                points={pointsOrderedByRoute}
            />
        );
    };

    get timelineProps() {
        const {
            workRestInfo,
            modal,
            enums,
            mergeMapViewport,
            refuelingServiceType,
            roles,
            organization,
            profile,
            refuelingSettings,
        } = this.props;
        const {
            bid,
            extendedPropertiesConfig,
            userEntityOptions,
            bid: {
                bidPoints,
                estimations,
                price,
                status,
                activeMileage,
                factEmptyMileageBefore,
                factEmptyOdometerMileageBefore,
            },
        } = this.state;
        const route = this.state.route || {};
        const hasEstimationData = !!estimations && estimations.length !== 0;
        const userPolicy = policy("user", { user: { profile, roles } });
        const latePeriod = hasEstimationData ? estimations[estimations.length - 1].latePeriod : null;
        return {
            points: sortedPoints(bidPoints),
            organization,
            getItem: this.getItem,
            mergeMapViewport,
            activeMileage,
            factEmptyMileageBefore,
            factEmptyOdometerMileageBefore,
            route,
            latePeriod,
            hasEstimationData,
            estimations,
            price,
            status,
            workRestInfo,
            modal,
            roles,
            extendedPropertiesConfig,
            canSeeEditPointDatesBtn: this.bidPolicy.canSeeEditPointDatesBtn,
            canSeeForceCompleteBtn: this.bidPolicy.canSeeForceCompleteBtn,
            canSetBidEstimatedLeaveDate: this.bidPolicy.canSetBidEstimatedLeaveDate,
            canSeePointPrediction: this.bidPolicy.canSeePointPrediction,
            canReorderBidPoints: this.bidPolicy.canDragPoint(),
            updateBidPointsOrder: this.updateBidPointsOrder,
            canEditPlanRefuelings: this.bidPolicy.canEditPlanRefuelings({ refuelingSettings }),
            loadUnloadType: enums.loadUnloadType,
            hasPlanEmptyMileageBidModule: userPolicy.hasPlanEmptyMileageBidModule(),
            bid,
            refuelingServiceType,
            enums,
            userEntityOptions,
            predictBidPoint: this.predictBidPoint,
        };
    }

    predictBidPoint = (bidPointId) => {
        const { mergeMapData } = this.props;
        const { id } = this.state.bid;
        mergeMapData({ isLoading: true, compareBidId: String(id) });
        return getPointPrediction(id, bidPointId).then((res) => {
            if (res) {
                setTimeout(() => {
                    mergeMapData({ pointPrediction: res, isLoading: false, compareBidId: String(id) });
                }, 500);
            } else {
                mergeMapData({ isLoading: false, compareBidId: String(id) });
            }
        });
    };

    mainInfoHeader = () => {
        const { bid } = this.state;
        const { toChat } = this.props;
        const { Default, Rate } = bidChatDomainTypesEnum;
        const chat = bid.chats.find((item) => [Default, Rate].includes(item.type));
        const chatId = chat && chat.id;
        const intChatFlags = chat && chat.intChatFlags;

        const btnProps = {
            value: "Открыть доступ",
            cname: "share inline-btn--brand",
            action: () => {
                const { modal } = this.props;
                ymEvent("share");
                return modal({
                    name: "default",
                    title: "Предоставление доступа к заявке",
                    CustomBody: CargoOwnerShareAccess,
                    bodyData: {
                        submit: giveAccessToBids,
                        initialState: {
                            shareAccessEnabled: true,
                            id: bid.cargoOwnerDictionaryItem.id,
                            kpp: bid.cargoOwnerDictionaryItem.kpp,
                            name: bid.cargoOwnerDictionaryItem.name,
                            inn: bid.cargoOwnerDictionaryItem.inn,
                            kppDisabled: !!bid.cargoOwnerDictionaryItem.kpp,
                            contactPerson: bid.cargoOwnerDictionaryItem.contactPerson,
                        },
                    },
                    onCloseAction: () => this.getItem(),
                });
            },
        };
        return (
            <div className="show-bid__section-header show-bid__section-header--with-btns">
                <div>
                    <span className="pr-2">Информация о заявке</span>
                    {this.bidPolicy.canSeeCargoOwnerShareAccessInShow() && (
                        <>
                            <InlineBtn {...btnProps} />
                            <a
                                className="show-bid__section-header--tooltip"
                                href="https://cargorun.ru/articles/obnovlieniie-sistiemy-cr-zaghruzki-ot-21-tochka-09-tochka-2023"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                ?
                            </a>
                        </>
                    )}
                </div>
                {chatId && (
                    <Notifys
                        cname="notifys__bell"
                        action={toChat.bind(this, chatId)}
                        chatId={chatId}
                        chatType={chatTypesEnum.BidChat}
                        intChatFlags={intChatFlags}
                        back={this.props.back}
                    />
                )}
            </div>
        );
    };

    renderDocuments = () => {
        const { documents } = this.state.bid;
        if (!documents || documents.length === 0) {
            return null;
        }
        return <BidDocuments documents={documents || []} />;
    };

    renderFactoring = () => {
        const { factoring } = this.state.bid;
        if (!factoring) {
            return null;
        }
        const { factoringCompanyName, sentAt } = factoring;
        return (
            <>
                <div className="show-bid__main-info--title">Факторинг</div>
                <div className="show-bid__main-info--value" data-test-id="factoring">
                    <strong>{factoringCompanyName}</strong>
                    <br />
                    <strong>{dateTimeToView(sentAt, "DD.MM.YYYY HH:mm (Z)")}</strong>
                </div>
            </>
        );
    };

    renderTemperatureRegime = () => {
        if (!this.temperatureRegimeEnabled) {
            return null;
        }
        const { temperatureRegime, temperature } = this.state.bid;
        if (
            !(
                temperatureRegime &&
                temperatureRegime.temperatureMinimum != null &&
                temperatureRegime.temperatureMaximum != null
            ) &&
            !temperature
        ) {
            return null;
        }
        return (
            <>
                <div className="show-bid__main-info--title">Температурный режим</div>
                <div className="show-bid__main-info--value" data-test-id="temperature-regime">
                    {temperatureRegime &&
                        temperatureRegime.temperatureMinimum != null &&
                        temperatureRegime.temperatureMaximum != null && (
                            <>
                                Критический диапазон: с {temperatureRegime.temperatureMinimum}℃ до{" "}
                                {temperatureRegime.temperatureMaximum}℃
                                <br />
                            </>
                        )}
                    Текущая температура
                    <Tooltip
                        placement="bottom"
                        overlay={
                            <>
                                {"Система начинает анализировать отклонения по температурным датчикам"}
                                <br />
                                {"после выезда ТС из точки А для исключения лишних оповещений."}
                            </>
                        }
                    >
                        <i className="icon-uEA69-question-circle b-point__tooltip-icon" />
                    </Tooltip>
                    : &nbsp;
                    {temperature && temperature.values.length > 0
                        ? temperature.values.map((value, index) => (
                              <div key={index}>
                                  Датчик №{index + 1}: {value}℃
                              </div>
                          ))
                        : "Нет данных"}
                    {temperature && temperature.fixedAt && (
                        <div className="text-muted">
                            обновлено в {dateTimeToView(temperature.fixedAt, "DD.MM.YYYY HH:mm (Z)")}
                        </div>
                    )}
                </div>
            </>
        );
    };

    renderEmptyMileageBid = () => {
        const { emptyMileageBid } = this.state.bid;
        if (!emptyMileageBid) {
            return null;
        }
        const { logisticReasonTypeId, technicalReason } = emptyMileageBid;
        const reasonObj = (this.props.enums.emptyMileageBidReasonType || []).find(
            (item) => item.value === logisticReasonTypeId,
        );
        const isMileagePaid = reasonObj?.itemOptions?.isMileagePaid;
        return (
            <>
                {logisticReasonTypeId && (
                    <>
                        <div className="show-bid__main-info--title">Причина порожнего пробега</div>
                        <div className="show-bid__main-info--value" data-test-id="logistic-reason-type">
                            {reasonObj?.label}
                        </div>
                    </>
                )}
                {isMileagePaid != null && (
                    <>
                        <div className="show-bid__main-info--title">Пробег оплачен</div>
                        <div className="show-bid__main-info--value" data-test-id="is-mileage-paid">
                            {isMileagePaid ? (
                                <span className="badge badge-success">Да</span>
                            ) : (
                                <span className="badge badge-danger">Нет</span>
                            )}
                        </div>
                    </>
                )}
                {technicalReason && (
                    <>
                        <div className="show-bid__main-info--title">Техническая причина порожнего пробега</div>
                        <div className="show-bid__main-info--value" data-test-id="technical-reason">
                            {technicalReason}
                        </div>
                    </>
                )}
            </>
        );
    };

    renderBidItemsChanges = () => {
        const { mergeMapViewport } = this.props;
        const { bidItemsChanges, bid } = this.state;
        const { hasItemsChange } = bid;
        if (!(hasItemsChange && bidItemsChanges)) {
            return null;
        }
        return <BidItemsChanges bidItemsChanges={bidItemsChanges} mergeMapViewport={mergeMapViewport} />;
    };

    skippedRefuelingsInfo = () => {
        const { fuelConsumption, id, hasSkippedRefuelings } = this.state.bid;
        const { availableFeatureModules } = this.props.profile;
        if (
            !fuelConsumption ||
            !availableFeatureModules.includes(featureModuleTypesEnum.RefuelingPlanning) ||
            this.props.refuelingSettings.hideRefuelingPlanning
        ) {
            return null;
        }
        return (
            <FuelInfo
                fuelConsumption={fuelConsumption}
                bidId={id}
                modal={this.props.modal}
                hasSkippedRefuelings={hasSkippedRefuelings}
            />
        );
    };

    renderEtrn = () => {
        if (!this.bidPolicy.hasEbillsAccess()) {
            return null;
        }

        const { bid } = this.state;
        return (
            <BidEBills
                bid={bid}
                modal={this.props.modal}
                getItem={this.getItem}
                powerOfAttorneys={this.props.profile.powerOfAttorneys}
                roles={this.props.roles}
                profile={this.props.profile}
            />
        );
    };

    renderShippingOrder = () => {
        if (!this.bidPolicy.hasEbillsAccess()) {
            return null;
        }

        const { bid } = this.state;
        const { history, organization } = this.props;
        return (
            <BidShippingOrder
                bid={bid}
                modal={this.props.modal}
                getItem={this.getItem}
                powerOfAttorneys={this.props.profile.powerOfAttorneys}
                canSignShippingOrderTitle={!this.bidPolicy.isReadOnlyTruckingOrganizationUser()}
                canStartBid={this.bidPolicy.canSeeHeadToWorkBtn({
                    usesBidsApproval: organization.usesBidsApproval,
                })}
                startBid={() => history.push(`${paths.bidEdit(bid.id)}?editRoute=true&confirmRoute=true`)}
                roles={this.props.roles}
            />
        );
    };

    renderParcelInfo = () => {
        const { organization } = this.props;
        const { bid } = this.state;
        if (organization.enabledParcelProviders?.length > 0 || bid.parcels?.length > 0) {
            return (
                <BidParcels
                    bid={bid}
                    modal={this.props.modal}
                    getItem={this.getItem}
                    relationType={parcelRelationTypesEnum.Bid}
                    providers={organization.enabledParcelProviders}
                />
            );
        } else {
            return null;
        }
    };

    renderBody = () => {
        if (!this.state.bid) {
            return null;
        }
        const { extendedPropertiesConfig } = this.state;
        const { extendedProperties, bidPoints } = this.state.bid;
        const lastPoint = bidPoints[bidPoints.length - 1];
        const usesStrictPlanEnterVal = bidPointOptionFlags.find(
            (item) => item.value === bidPointOptionFlagsEnum.UsesStrictPlanEnter,
        ).intValue;
        return (
            <div className="show-bid__sections">
                {this.mainInfoHeader()}
                <div className="show-bid__main-info">
                    {this.renderCompoundInfo()}
                    {this.renderPricing()}
                    {this.renderTruck()}
                    {this.renderDriver()}
                    {this.renderFactoring()}
                    {this.renderLogist()}
                    {this.renderMechanic()}
                    {this.renderLegalPerson()}
                    {this.renderCargoOwner()}
                    {this.renderContractNumber()}
                    {this.renderContract()}
                    {this.renderCreatedAtInfo()}
                    {this.renderApprovedAtInfo()}
                    {this.renderStartedAtInfo()}
                    {this.renderResponsibleInfo()}
                    {this.renderSalesManagerInfo()}
                    {this.renderWeightInfo()}
                    {this.renderDocumentAssigmentStatus()}
                    {this.renderDistributionBidInfo()}
                    {this.renderTemperatureRegime()}
                    {this.renderEmptyMileageBid()}
                    {this.renderComment()}
                    {this.renderClientBidNumber()}
                    {this.renderClientBidDate()}
                    <BidSyncStatusInfo organizationTimezone={this.props.organizationTimezone} bid={this.state.bid} />
                    {this.renderTypeOptions()}
                    {this.renderExtendedProperties(extendedPropertiesConfig.bid, extendedProperties)}
                </div>
                {this.renderEtrn()}
                {this.renderShippingOrder()}
                {this.renderBidItemsChanges()}
                {this.renderParcelInfo()}
                <div className="show-bid__section-header">
                    Маршрут
                    <div className="d-flex align-items-center">
                        {this.skippedRefuelingsInfo()}
                        {(lastPoint.intOptions & usesStrictPlanEnterVal) === usesStrictPlanEnterVal && (
                            <Tooltip
                                placement="right"
                                overlay="Загрузка и выгрузка строго по заданию"
                                overlayClassName="show-bid__route--tooltip"
                            >
                                <span className="ml-2">
                                    <i className="icon-uEA81-lock" />
                                </span>
                            </Tooltip>
                        )}
                    </div>
                </div>
                {this.renderTimeline()}
                {this.renderCargoPoints()}
                {this.renderDocuments()}
                {this.renderTollRoads()}
            </div>
        );
    };

    render() {
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        return (
            <div className="page-book__list show-bid">
                {this.renderHead()}
                {this.renderActions()}
                <div className="show-bid__body-wrapper">
                    <div className="h-100 overflow-auto">{this.renderBody()}</div>
                </div>
            </div>
        );
    }
}

export default connect(BidShow);
